import useChangeUserPhone from './useChangeUserPhone'

export default useChangeUserPhone
